<template>
  <div class="wrapper">
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text">会员基本信息<span class="title-tip"></span></span>
      </div>
    </div>
    <div class="white-bg-radius">
      <component 
        :is="componentCheck"
        :baseInfoData="baseInfoData"
        @getDistributer="getDistributerDeatil"
      ></component>
    </div>
  </div>
</template>
<script>
import { findDistributerDeatil } from '../../api/request'
import baseInfo from './common/baseInfo.vue'
export default {
  name: 'distributorBaseInfo',
  components: {
    baseInfo
  },
  data() {
    return {
      swichIndex: 1, // 控制现在在那个tab上面
      baseInfoData: {}
    }
  },
  computed: {
    componentCheck() {
      const obj = {
        '1': 'baseInfo'
      }
      return obj[this.swichIndex]
    }
  },
  created() {
    this.getDistributerDeatil()
  },
  methods: {
    // 分销商管理详情基本信息接口
    getDistributerDeatil() {
      findDistributerDeatil('/customer/user/findDistributerDeatilById/' + this.$route.query.id, 'get')
        .then(res => {
          if (res.code === 0) {
            this.baseInfoData = res.data
          } else if (res.code === 1001) {
            this.$message('服务器内部异常')
          } else if (res.code === 1002) {
            this.$message('登录凭证无效')
          } else {
            this.$message('没有权限')
          }
        })
        .catch(errData => {
          this.$message.error('error 出错了')
          console.log(errData)
        })
    },
    swicthTab(num) {
      this.swichIndex = num
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
  .wrapper{
    flex: 1 1 0%; display: flex; flex-direction: column;
  }
  .white-bg-radius{
    // border-radius:0;
    margin-top:10px;
    padding:20px;
  }
  .tab_switch{
    margin:0 20px;
  }
</style>


// WEBPACK FOOTER //
// src/_app/outlet/src/views/memberBaseInfo/index.vue